/// <reference path="../../public/jquery-1.6.2.min.js" />
/// <reference path="../../public/General.js" />
/// <reference path="../../SumoDataAccess.js" />
/// <reference path="../../SumoClass.js" />
/// <reference path="../ControlBase.js" />

if (isNullOrUndefined(sumo)) {
    throw ('CardView.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.controls)) {
    throw ('CardView.js requies the sumo.controls namespace defined in ControlBase.js');
}

// options
//  keyField
//  keyFieldType: string, number
//  selectMethod: single, auto, ctrlKey, none
//  cssClass
//  canUnselect
//  oddRowClass
//  evenRowClass
/**
 * @module Core
 * @namespace sumo.controls.CardView
 * @param  {} aId
 * @param  {} aParentId
 * @param  {} aOptions
 * @example
 * var lViewState = getViewState('EnrolleesSelectedEnrollee'),
        lSortState = getViewState('EnrolleesCardViewSort');
    mEnrolleesControls.CardView = new sumo.controls.CardView('uEnrolleesCardView', 'uEnrolleesListHolder', {
        'cardTemplate': 'Interface/Enrollees.Card.Template.htm', 'selectMethod': 'single', 'canUnselect': false, 'cssClass': 'VeritracksCardView', 'keyField': 'Id', 'isSortable': true, 'Columns': [
            { 'id': 'FullName', 'title': localizeWrapper('cEnrolleeLastName') + ', ' + localizeWrapper('cEnrolleeFirstName') },
            { 'id': 'FirstName', 'title': localizeWrapper('cEnrolleeFirstName') },
            { 'id': 'LastName', 'title': localizeWrapper('cEnrolleeLastName') },
            { 'id': 'PrimaryId', 'title': localizeWrapper('cEnrolleePrimaryId') },
            { 'id': 'LastContactDate', 'title': localizeWrapper('cInventoryLastContactDate') },
            { 'id': 'LastTrackpointDate', 'title': localizeWrapper('cEnrolleeLastTrackDate') }
        ]
    });
    mEnrolleesControls.CardView.bind('selectedchanged',uEnrolleesCardView_OnSelectChange);
    // mEnrolleesControls.CardView.bind('databind', cardView_OnDataBind);
    mEnrolleesControls.CardView.bind('update', uEnrolleesCardView_OnUpdate);
    mEnrolleesData.IsCardViewInitialized = true;
    mEnrolleesControls.CardView.bind('sort', uEnrolleesCardView_OnSort);
 */
sumo.controls.CardView = function (aId, aParentId, aOptions) {
    "use strict";

    sumo.controls.CardView.prototype.baseClass.call(this, aId, aParentId,
        '<div class="sumo-cardview-control" id="##id##" style="height: 100%; overflow: hidden;"></div>',
        aOptions);

    var mThis = this,
        mSelectedKey = null,
        mPreviousSelectedKey = null,
        mViewIndex = [],
        mDataIndex = {},
        mDataSource = null,
        mIsDirty = false,
        mIsInitialized = false,
        mTemplateHtml = '',

    // options
        mKeyField = null,
        mKeyFieldType = 'string',
        mSelectMethod = 'single',
        mCssClass = null,
        mCanUnselect = false,
        mAlternateShadingEnabled = false,
        mOddRowClass = null,
        mEvenRowClass = null,
        mCardTemplate = '',
        mTemplateType = 'uri',
        mIgnoreOnClick = null,
        mPreSelectFirstCard = false,

    // html/jquery elements
        mViewPort = null,
        mRows = null,
        mUpdatedRow = null,
        mSortButton = null,
        mSortContainerToggleButton = null,
        mSortedColumn = {},
        mSelectedDirection = null,
        mToggled = false,
        mSelectedColumn = null;
        

    if (!this.isNothing(aOptions)) {
        if (!this.isNothing(aOptions.keyField)) {
            mKeyField = aOptions.keyField;
        }
        if (!this.isNothing(aOptions.keyFieldType)) {
            mKeyFieldType = aOptions.keyFieldType;
        }
        if (!this.isNothing(aOptions.selectMethod)) {
            mSelectMethod = aOptions.selectMethod;
        }
        if (!this.isNothing(aOptions.cssClass)) {
            mCssClass = aOptions.cssClass;
        }
        if (!this.isNothing(aOptions.canUnselect)) {
            mCanUnselect = aOptions.canUnselect;
        }
        if (!this.isNothing(aOptions.oddRowClass)) {
            mOddRowClass = aOptions.oddRowClass;
        }
        if (!this.isNothing(aOptions.evenRowClass)) {
            mEvenRowClass = aOptions.evenRowClass;
        }
        if (!this.isNothing(aOptions.cardTemplate)) {
            mCardTemplate = aOptions.cardTemplate;
        }
        if (!this.isNothing(aOptions.templateType)) {
            mTemplateType = aOptions.templateType;
        }
        if (!this.isNothing(aOptions.IgnoreOnClick)) {
            mIgnoreOnClick = aOptions.IgnoreOnClick;
        }
        if (!this.isNothing(aOptions.preSelectFirstCard)) {
            mPreSelectFirstCard = aOptions.preSelectFirstCard;
        }
    }

    function onInitialized(aSender, aEventParameters, aData) {
        aSender.unbind('initialized', onInitialized);
        aSender.render();
    }

    function loadTemplateSuccess(responseText, textStatus, XMLHttpRequest) {
        mTemplateHtml = responseText;
        mIsInitialized = true;
        if (!isNullOrUndefined(mThis)) {
            mThis.trigger('initialized', null);
        }
    }

    function loadTemplateHtml() {
        $.get(mCardTemplate, loadTemplateSuccess);
    }

    function bindDataToTemplate(aString, aItem) {
        var lKey,
            lPropertyValue,
            lFormattedValue,
            lSearchKey,
            lResult = aString;
        for (lKey in aItem) {
            if (aItem.hasOwnProperty(lKey)) {
                lPropertyValue = aItem[lKey];
                lFormattedValue = '';
                if (!mThis.isNothing(lPropertyValue)) {
                    lFormattedValue = lPropertyValue.toString();
                }
                lSearchKey = '##' + lKey + '##';
                while (lResult.indexOf(lSearchKey) !== -1) {
                    lResult = lResult.replace(lSearchKey, lFormattedValue);
                }
            }
        }
        return lResult;
    }

    function getBodyContent() {
        var lHtml = [],
            lRowKey = null,
            lRow = null,
            lRowIndex = 0;

        mViewIndex = [];
        mDataIndex = {};
        for (lRowKey in mDataSource) {
            if (mDataSource.hasOwnProperty(lRowKey)) {
                lRow = mDataSource[lRowKey];
                if (mThis.isNothing(lRow)) {
                    throw (mThis.className() + '.Id: ' + mThis.Id + '. Error binding data. Item with hash index of ' + lRowKey.toString() + ' does not exist.');
                }
                lHtml.push('<div class="sumo-data-row" id="');
                lHtml.push(mThis.Id);
                lHtml.push('Row');
                if (mKeyField !== null) {
                    mViewIndex.push(lRow[mKeyField]);
                    mDataIndex[lRow[mKeyField]] = lRowKey;
                    lHtml.push(lRow[mKeyField]);
                } else {
                    mViewIndex.push(lRowKey);
                    mDataIndex[lRowKey] = lRowKey;
                    lHtml.push(lRowKey);
                }
                lHtml.push('" itemkey="');
                lHtml.push(lRowIndex.toString());
                lHtml.push('">');
                lHtml.push(bindDataToTemplate(mTemplateHtml, lRow));
                lHtml.push('</div>');
                ++lRowIndex;
            }
        }

        // if no data, then add empty row
        //        if (lRowIndex === 0) {
        //            lHtml.push('<div class="sumo-data-row">[No Data]</div>');
        //        }
        return lHtml.join('');
    }

    function selectRow(aKey) {
        mViewPort.find('#' + mThis.Id + 'Row' + aKey).addClass('sumo-data-row-selected');
    }

    function unselectRow(aKey) {
        mViewPort.find('#' + mThis.Id + 'Row' + aKey).removeClass('sumo-data-row-selected');
    }

    function multiSelect(aKey) {
        var lIndex = null;

        if ((mSelectedKey === null) || (mSelectedKey.constructor !== Array)) {
            mSelectedKey = [];
        }
        // don't allow select if the item is not in the list
        if (mViewIndex.indexOf(aKey) !== -1) {
            lIndex = mSelectedKey.indexOf(aKey);
            if (lIndex === -1) {
                selectRow(aKey);
                mSelectedKey.push(aKey);
            } else {
                if (mSelectedKey.length > 1 || mCanUnselect) {
                    unselectRow(aKey);
                    mSelectedKey.splice(lIndex, 1);
                }
            }
        }
    }

    function unselectAll() {
        mViewPort.find('.sumo-data-row-selected').removeClass('sumo-data-row-selected');
        mSelectedKey = null;
    }

    function selectList(aKeyList) {
        var lIndex = null,
            lLength = aKeyList.length;

        unselectAll();
        mSelectedKey = [];

        lLength = aKeyList.length;
        for (lIndex = 0; lIndex < lLength; lIndex++) {
            multiSelect(aKeyList[lIndex]);
        }
    }

    function selectSingle(aKey) {
        var lItems = null,
            wasSelected = false;

        if (mCanUnselect && aKey === mSelectedKey) {
            unselectRow(mSelectedKey);
            mSelectedKey = null;
            wasSelected = true;
        } else if (!mCanUnselect && aKey === mSelectedKey && mViewIndex.indexOf(mSelectedKey) === -1) {
            // if can't unselected and the keys match and the selected key is no longer in the data source
            // then set the selection to the first item in the list
            if (mViewIndex.length > 0) {
                mThis.selectedIndex(0);
            } else {
                mSelectedKey = null;
            }
        } else {
            // don't allow select if the item is not in the list
            if (mViewIndex.indexOf(aKey) !== -1) {
                unselectRow(mSelectedKey);
                selectRow(aKey);

                lItems = mViewPort.find('#' + mThis.Id + 'Row' + aKey + '.sumo-data-row-selected');
                if (lItems.length > 0 && !isScrolledIntoView(lItems[0])) {
                    lItems[0].scrollIntoView(true);
                }

                mPreviousSelectedKey = mSelectedKey;
                mSelectedKey = aKey;
            }
        }
        return wasSelected;
    }

    // MARK: 10 JAN 2013
    // this returns the wrong value - it doesn't work when there are scroll bars present
    function isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }

    function select(aKey, aCtrlKey) {
        var wasSelected = null;
        if (!mThis.isNothing(aKey)) {
            mThis.trigger('selectedchanging', { 'Current': mSelectedKey, 'New': aKey });
            if ((aKey.constructor === Array) && (mSelectMethod === 'auto' || mSelectMethod === 'ctrlKey')) {
                selectList(aKey);
            } else if (mSelectMethod === 'single') {
                if (aKey.constructor === Array) {
                    throw (mThis.className() + '.Id: ' + mThis.Id + '. Invalid argument. Cannot pass Array to select() with selectMethod of single.');
                }
                wasSelected = selectSingle(aKey);
            } else if (mSelectMethod === 'auto' || (mSelectMethod === 'ctrlKey' && aCtrlKey === true)) {
                multiSelect(aKey);
            } else if (mSelectMethod === 'ctrlKey' && aCtrlKey === false) {
                unselectAll();
                multiSelect(aKey);
            }
            mThis.trigger('selectedchanged', mSelectedKey);
        }
        return wasSelected;
    }

    //check if null
    this.getPreviousSelectedKey = function(){
        return mPreviousSelectedKey;
    }

    this.selectedIndex = function (aSelectedIndex) {
        var lResult = null,
            lKey;
        if (this.isNothing(aSelectedIndex)) {
            lResult = mViewIndex.indexOf(mSelectedKey);
        } else {
            lKey = mViewIndex[aSelectedIndex];
            if (!this.isNothing(lKey)) {
                this.selected(lKey);
            }
        }
        return lResult;
    };

    this.selected = function (aSelectedKey, aAddItem) {
        var lResult = null,
            lAddItem = false;
        if (this.isNothing(aSelectedKey)) {
            lResult = mSelectedKey;
        } else {
            if (!this.isNothing(aAddItem)) {
                lAddItem = aAddItem;
            }
            select(aSelectedKey, lAddItem);
        }
        return lResult;
    };

    this.selectedDataItem = function () {
        var lResult = null,
            i;
        if (!mThis.isNothing(mSelectedKey)) {
            if (mSelectedKey.constructor !== Array) {
                lResult = mDataSource[mDataIndex[mSelectedKey]];
            } else {
                lResult = [];
                for (i = 0; i < mSelectedKey.length; i++) {
                    lResult.push(mDataSource[mDataIndex[mSelectedKey[i]]]);
                }
            }
        }
        return lResult;
    };

    this.selectedDataItemById = function (aId) {
        var lResult = null;

        lResult = mDataSource[mDataIndex[aId]];
        
        return lResult;
    }

    this.updateSingleItem = function (aNewItem) {
        var lHtml = [];

        lHtml.push(bindDataToTemplate(mTemplateHtml, aNewItem));
        var lRowUpdate = mThis.ControlElement.find("#" + mThis.Id + "Row" + aNewItem[mKeyField]);
        lRowUpdate[0].innerHTML = lHtml.join('');
    };

    this.markItemAsDisabled = function (aMarkedItem) {
        var lRowUpdate = mThis.ControlElement.find("#" + mThis.Id + "Row" + aMarkedItem[mKeyField]);
        lRowUpdate.addClass('sumo-data-row-deleted');
    };

    this.markItemAsEnabled = function (aMarkedItem) {
        var lRowUpdate = mThis.ControlElement.find("#" + mThis.Id + "Row" + aMarkedItem[mKeyField]);
        lRowUpdate.removeClass('sumo-data-row-deleted');
    };

    function row_OnClick(aEvent) {
        // "this" refers to the object raising the event
        var lRow = $(this),
            lRowIndex = lRow.attr('itemkey'),
            lSelectedKey = mViewIndex[parseInt(lRowIndex, 10)],
            lSkip = false,
            wasSelected;

        if (!isNullOrUndefined(mIgnoreOnClick) && !isNullOrUndefined(aEvent.target)) {
            if (mIgnoreOnClick.indexOf(aEvent.target.className) != -1 && lRow.hasClass("sumo-data-row-selected")) {
                lSkip = true;
            }
        }
        if (!lSkip) {
            aEvent.stopImmediatePropagation();
            wasSelected = select(lSelectedKey, aEvent.ctrlKey);
            if (aEvent.currentTarget.id.indexOf('uTrackpointDetailCardView') != -1) {
                if (wasSelected) {
                    var mMap = mEnrolleesControls.EnrolleesMap.getMap();
                    if (veritracks.enrollees.mapping.data.PreviousZoom > 18) {
                        // default zoom if currently zoomed in real close 
                        veritracks.enrollees.mapping.PreviousZoom(14);
                    }
                    mMap.setZoom(veritracks.enrollees.mapping.data.PreviousZoom);
                } else {
                    veritracks.enrollees.mapping.zoomOut(mEnrolleesControls.EnrolleesMap.getMap(), 2);
                }
            }
        }
    }

    function resizeViewPort() {
        var lHeight = mThis.ControlElement.innerHeight();
        if (mViewPort !== null) {
            if (mUpdatedRow.is(":visible")) {
                lHeight = lHeight - mUpdatedRow.height();
            }
            if (mSortContainerToggleButton.is(":visible")) {
                lHeight = lHeight - mSortContainerToggleButton.height();
            }
            mThis.ControlElement.height(mThis.ParentElement.innerHeight());
            mViewPort.height(lHeight);

        }
    }

    this.resize = function () {
        resizeViewPort();
    };

    this.setUpdated = function (aIsUpdated) {
        if (!mThis.isNothing(mUpdatedRow)) {
            if (aIsUpdated) {
                mUpdatedRow.show();
            } else {
                mUpdatedRow.hide();
            }
        }
        resizeViewPort();
    };

    this.isUpdateVisible = function () {
        var lUpdate = false;

        if (mUpdatedRow.is(":visible")) {
            lUpdate = true;
        }

        return lUpdate;
    }
    function mUpdatedRow_OnClick() {
        mThis.trigger('update', null);

    }

    function sortContainerToggleButton_OnClick() {
        if (!mToggled) {
            mToggled = true;
            veritracks.localization.localize('#u' + mThis.Id + 'CardViewSortContainer');
        }
        if ($('#u' + mThis.Id + 'CardViewSortContainer').is(":visible")) {
            $('#u' + mThis.Id + 'CardViewSortContainer').hide();
        } else {
            $('#u' + mThis.Id + 'CardViewSortContainer').show();
        }
    }

    function generateSortExpression(aColumnId, aSortDirection) {
        var lSort = new SortExpression(),
            lColumnId = aColumnId.split(mThis.Id);

        if (aSortDirection.toLowerCase() === 'ascending') {
            lSort.addAscendingColumn(lColumnId[(lColumnId.length - 1)]);
        } else {
            lSort.addDescendingColumn(lColumnId[(lColumnId.length - 1)]);
        }
        return lSort;
    }

    this.sortExpression = function (aSortExpression, aColumnId, aDirection) {

        if (mThis.isNothing(aSortExpression)) {
            return generateSortExpression(mSortedColumn.ColumnName, mSortedColumn.SortDirection);
        } else {
            //set values from sort expression
            mSortedColumn.ColumnName = aSortExpression.Columns[0].ColumnName;
            mSortedColumn.SortDirection = aSortExpression.Columns[0].Direction.toLowerCase();
            mThis.trigger('sort', generateSortExpression(mSortedColumn.ColumnName, mSortedColumn.SortDirection));
        }
    };

    function mCardViewSortButton_OnClick(aColumnId, aSortDirection) {
        var lSelectedSortDirection = mThis.ControlElement.find('input:radio[name=ColumnSortDirectionRadioButton]:checked').val(),
            lColumnName = aColumnId.split(mThis.Id);
        mSortedColumn.ColumnName = lColumnName[(lColumnName.length - 1)];
        mSortedColumn.SortDirection = lSelectedSortDirection;
        mThis.trigger('sort', generateSortExpression(aColumnId, lSelectedSortDirection));
    }

    function dataBind() {
        if (mIsInitialized) {
            var lHtml = [],
                lKey,
                lColumn,
                lRowId;
            if (mIsDirty && !mThis.isNothing(mDataSource)) 
            {
                if (mThis.Options.isSortable === true) {
                    lHtml.push('<div class="CardViewSortContainerToggleButton" id="u');
                    lHtml.push(mThis.Id);
                    lHtml.push('CardViewSortContainerToggleButton');                    
                    lHtml.push('"></div>');
                    lHtml.push('<div class="CardViewSortContainer" id="u');
                    lHtml.push(mThis.Id);
                    lHtml.push('CardViewSortContainer"><table>');
                    for (lKey in mThis.Options.Columns) {
                        if (mThis.Options.Columns.hasOwnProperty(lKey)) {
                            lColumn = mThis.Options.Columns[lKey];
                            lHtml.push('<tr>');
                            lHtml.push('<td><input type="radio" id="');
                            lRowId = mThis.Id + lColumn.id;
                            lHtml.push(lRowId);
                            lHtml.push('" name="ColumnSortRadioButton" class="');
                            lHtml.push(mThis.Id);
                            lHtml.push('ColumnSortRadioButton ColumnSortRadioButton" /></td>');
                            lHtml.push('<td><label for="');
                            lHtml.push(lRowId);
                            lHtml.push('">');
                            lHtml.push(lColumn.title);
                            lHtml.push('</label>');
                            lHtml.push('</td>');
                            lHtml.push('</tr>');
                        }
                    }

                    lRowId = mThis.Id + 'Ascending';
                    lHtml.push('<tr><td colspan="2"><hr/></td></tr>');
                    lHtml.push('<tr>');
                    lHtml.push('<td>');
                    lHtml.push('<input type="radio" id="');
                    lHtml.push(lRowId);
                    lHtml.push('" name="ColumnSortDirectionRadioButton" class="ColumnSortDirectionRadioButton" checked="checked" value="ascending" />');
                    lHtml.push('</td>');
                    lHtml.push('<td>');
                    lHtml.push('<label for="');
                    lHtml.push(lRowId);
                    lHtml.push('">' + localizeWrapper('cAscending') + '</label>');
                    lHtml.push('</td>');
                    lHtml.push('</tr>');

                    lRowId = mThis.Id + 'Descending';
                    lHtml.push('<tr>');
                    lHtml.push('<td>');
                    lHtml.push('<input type="radio" id="');
                    lHtml.push(lRowId);
                    lHtml.push('" name="ColumnSortDirectionRadioButton" class="ColumnSortDirectionRadioButton" value="descending" />');
                    lHtml.push('</td>');
                    lHtml.push('<td>');
                    lHtml.push('<label for="');
                    lHtml.push(lRowId);
                    lHtml.push('">' + localizeWrapper('cDescending') + '</label>');
                    lHtml.push('</td>');
                    lHtml.push('</tr>');

                    lHtml.push('</table>');

                    lHtml.push('<div class="ButtonBar"><div class="ButtonCommandBar"><div class="CardViewSortButton Button LargeIconButton Clickable ContinueButton" id="u');
                    lHtml.push(mThis.Id);
                    lHtml.push('SortButton"');
                    lHtml.push('>' + localizeWrapper('cSort') + '</div>');
                    lHtml.push('</div></div></div>');
                }
                lHtml.push('<div id="');
                lHtml.push(mThis.Id); /// <reference path="../../Public/jquery.dateFormat-1.0.min.js" />
                lHtml.push('Updated" class="sumo-cardview-updated"><div class="sumo-cardview-datarefresh">'+ localizeText('cUpdateAvailable')+'</div>');
                lHtml.push('</div>');

                lHtml.push('<div id="');
                lHtml.push(mThis.Id);
                lHtml.push('ViewPort" class="sumo-cardview-viewport" style="height: 0px; overflow: auto;">');
                lHtml.push(getBodyContent());
                lHtml.push('</div>');
                
                //escape html for security
                mThis.ControlElement.html(veritracks.system.encodeHtml(lHtml.join('')));
                var encodedTextHtml = mThis.ControlElement.text();
                mThis.ControlElement.html(encodedTextHtml);
                
                mViewPort = mThis.ControlElement.find('#' + mThis.Id + 'ViewPort');
                mRows = mViewPort.find('.sumo-data-row');
                mUpdatedRow = mThis.ControlElement.find('#' + mThis.Id + 'Updated');
                mSortContainerToggleButton = mThis.ControlElement.find('#u'+mThis.Id+'CardViewSortContainerToggleButton');
                mSortContainerToggleButton.click(sortContainerToggleButton_OnClick);
                mRows.click(row_OnClick);
                mUpdatedRow.click(mUpdatedRow_OnClick);
                mSortButton = mThis.ControlElement.find('#u' + mThis.Id + 'SortButton');
                mSelectedColumn = mThis.ControlElement.find('.' + mThis.Id + 'ColumnSortRadioButton');
                
                if (!mThis.isNothing(mSortedColumn) && !mThis.isNothing(mSortedColumn.ColumnName) && !mThis.isNothing(mSortedColumn.SortDirection)) {
                    mThis.ControlElement.find('#' + mThis.Id + mSortedColumn.ColumnName).attr('checked', true);
                    if (mSortedColumn.SortDirection === 'ascending') {
                        mThis.ControlElement.find('#' + mThis.Id + 'Ascending').attr('checked', true);
                    } else {
                        mThis.ControlElement.find('#' + mThis.Id + 'Descending').attr('checked', true);
                    }
                }

//mSortedColumn.ColumnName = aSortExpression.Columns[0].ColumnName;
//mSortedColumn.SortDirection = aSortExpression.Columns[0].Direction.toLowerCase();


                mSortButton.click(function (aEvent) {
                    var lSelectedColumn = mThis.ControlElement.find('input:radio[name=ColumnSortRadioButton]:checked');
                    if (!mThis.isNothing(lSelectedColumn[0])) {
                        mCardViewSortButton_OnClick(lSelectedColumn[0].id);
                    }
                });

                if (mSelectMethod !== 'none') {
                    mRows.addClass('sumo-selectable');
                }
                if (mOddRowClass !== null) {
                    mViewPort.find('tr:odd').addClass(mOddRowClass)
                                    .addClass('sumo-data-row-odd');
                }
                if (mEvenRowClass !== null) {
                    mViewPort.find('tr:even').addClass(mEvenRowClass)
                                     .addClass('sumo-data-row-even');
                }
                
                if (!mThis.isNothing(mSelectedKey)) {
                    select(mSelectedKey, false);
                }
                mThis.setUpdated(false);

                mIsDirty = false;
                var lCardViewFirstElement = mThis.ControlElement.find('#' + mThis.Id + 'ViewPort').find('.sumo-data-row').first();
                // use a Flag to pre-select first after render
                if (lCardViewFirstElement && mPreSelectFirstCard) {
                    lCardViewFirstElement.trigger("click");
                }
                mThis.trigger('databind');
            }
        }
    }
    this.setDataSource = function (aDataSource) {
        mDataSource = aDataSource;
        mIsDirty = true;
        if (!this.isNothing(mDataSource)) {
            dataBind();
        }

        veritracks.localization.localize('#' + mThis.Id);
    };

    this.getDataSource = function () {
        return mDataSource;
    };

    this.show = function () {
        if (mIsDirty) {
            dataBind();
        }
        sumo.controls.CardView.prototype.show.call(this);
    };
    
    this.scrollTop = function (aId) {
        var lOffset = 0;
        if (mViewPort) {
            mViewPort.scrollTop(lOffset);
            if (!mThis.isNothing($('#' + mThis.Id + 'Row' + aId).offset())) {
                lOffset += $('#' + mThis.Id + 'Row' + aId).offset().top;
                lOffset -= mViewPort.offset().top;
            }
            mViewPort.scrollTop(lOffset);
        }
    };

    function window_OnResize(e) {
        resizeViewPort();
    }

    this.dispose = function () {
        $(window).unbind('resize', window_OnResize);
        if (!mThis.isNothing(mRows)) {
            mRows.unbind('click', row_OnClick);
        }

        mSelectedKey = null;
        mViewIndex = null;
        mDataIndex = null;
        mDataSource = null;
        mKeyField = null;
        mCssClass = null;
        mOddRowClass = null;
        mEvenRowClass = null;
        mViewPort = null;
        mRows = null;

        mThis = null;

        sumo.controls.CardView.prototype.dispose.call(this);
    };

    this.render = function () {
        if (!mIsInitialized) {
            if (mTemplateType === 'uri') {
                this.bind('initialized', onInitialized, null);
                loadTemplateHtml(this);
                return 0;
            } else {
                mTemplateHtml = mCardTemplate;
                mIsInitialized = true;
            }
        }
        if (mIsDirty && !this.isNothing(mDataSource)) {
            dataBind();
        }
        if (!this.isNothing(mCssClass)) {
            this.ControlElement.addClass(mCssClass);
        }
        $(window).resize(window_OnResize);
        veritracks.localization.localize('#' + mThis.Id);
        veritracks.localization.localizeTitle('#' + mThis.Id);
        this.trigger('render');
    };

    this.render();
};
sumo.controls.CardView.prototype = new sumo.controls.ControlBase();
sumo.controls.CardView.prototype.constructor = sumo.controls.CardView;
sumo.controls.CardView.prototype.baseClass = sumo.controls.ControlBase;